/*
 * Floating add-to-cart bar (Product information block).
 *
 * Shows a sticky bottom bar (price + add-to-cart) only while the "Price Buy Button"
 * block is scrolled out of the viewport. The bar owns no product form: it mirrors
 * the live price node and proxies clicks to the real add-to-cart button, so the whole
 * existing pipeline (product-form.js cart drawer, product-info.js variant updates,
 * CH price formatting) is reused as-is.
 */
(function () {
  function initBar(bar) {
    if (bar.dataset.fabInit === 'true') return;
    bar.dataset.fabInit = 'true';

    var sectionId = bar.dataset.sectionId;
    var floatingPrice = document.getElementById('price-floating-' + sectionId);
    var floatingButton = bar.querySelector('.floating-atc-bar__button');
    var floatingButtonText = bar.querySelector('.floating-atc-bar__button-text');
    var realButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var priceSource = document.getElementById('price-buy-button-' + sectionId);

    // Viewport anchor: prefer the Price-Buy-Button block, then the Price block,
    // then the real add-to-cart button. If none exist the bar stays hidden.
    var anchor =
      priceSource ||
      document.getElementById('price-' + sectionId) ||
      realButton;

    if (!anchor) return;

    // Proxy the add-to-cart action to the real submit button (product-form.js handles it).
    if (floatingButton && realButton) {
      floatingButton.addEventListener('click', function () {
        if (realButton.hasAttribute('disabled')) return;
        realButton.click();
      });
    }

    // Mirror price + button state from the real controls. product-info.js updates
    // #price-buy-button-<id> and the real submit button before publishing variantChange.
    function sync() {
      if (floatingPrice && priceSource) {
        floatingPrice.innerHTML = priceSource.innerHTML;
      }
      if (floatingButton && realButton) {
        floatingButton.disabled = realButton.hasAttribute('disabled');
        var realText = realButton.querySelector('span');
        if (floatingButtonText && realText) {
          floatingButtonText.textContent = realText.textContent.trim();
        }
      }
    }

    sync();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || String(event.data.sectionId) !== String(sectionId)) return;
        sync();
      });
    }

    // Visibility is gated by two thresholds:
    //  - reveal once the in-page price/buy anchor has scrolled ABOVE the viewport
    //    (i.e. the shopper has scrolled past it); while the anchor is still below
    //    the viewport — e.g. on initial load near the top of the page — stay hidden,
    //  - hide again once the page footer scrolls into view, so the floating bar
    //    is dismissed near the end of the page.
    if ('IntersectionObserver' in window) {
      // Last <footer> in the DOM is the page footer (regardless of footer section
      // variant), and avoids matching an article's <footer> higher up the page.
      var footers = document.querySelectorAll('footer');
      var footer = footers.length ? footers[footers.length - 1] : null;

      var anchorAbove = false;
      var footerIn = false;

      var update = function () {
        var show = anchorAbove && !footerIn;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      };

      var anchorObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          // Direction matters: the anchor is "above" only when its bottom edge is at
          // or past the viewport top. A below-the-viewport anchor (initial load) is
          // also non-intersecting but must NOT reveal the bar.
          var rootTop = entry.rootBounds ? entry.rootBounds.top : 0;
          anchorAbove = entry.boundingClientRect.bottom <= rootTop;
          update();
        },
        { threshold: 0 }
      );
      anchorObserver.observe(anchor);

      if (footer) {
        var footerObserver = new IntersectionObserver(
          function (entries) {
            footerIn = entries[0].isIntersecting;
            update();
          },
          { threshold: 0 }
        );
        footerObserver.observe(footer);
      }
    }
  }

  function init() {
    document.querySelectorAll('.floating-atc-bar').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
